import formTpl from './base';

export { formTpl }